
import { Table, Stack, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Divider, Grid, Typography, Tooltip, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar } from "@mui/material";

import { styled } from '@mui/material/styles';

import { useState, useEffect, useRef } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import PropTypes from 'prop-types';
import { tokens } from "../../../theme/theme";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';

import CallAlertBar from "../../../Layout/Alertbar";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import useEmployee from "../../../hooks/useEmployee";

import PurchaseInspectionActionMenu from "./PurchaseInspectionMenu";
import usePurchaseInspectionDetailsById from "../../../hooks/useInspectionDetailById";
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import Header from "../../../Layout/Header";
import CustomTableContainer from "../../../Layout/CustomTableContainer";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const EmployeeSelector = ({ label, employeeList, selectedEmployee, onChange, disable }) => (
    <Autocomplete
        size="small"
        fullWidth
        options={employeeList}
        disabled={disable}
        value={selectedEmployee}
        onChange={(event, newValue) => onChange(newValue)}
        getOptionLabel={(option) => option?.name || ''}
        renderInput={(params) => (
            <TextField {...params} label={label} required variant="outlined" />
        )}
    />
);

const AddNewPurchaseInspection = ({ handlecallback, editPurchaseOrderNumber, editPurchaseReceiveNumber, editPurchaseReceiveID, editPurchaseReturnID, editPurchaseReturnNumber, selectedMode, setSelectedMode, formMode }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const approvedByHook = useEmployee();
    const inspiredByHook = useEmployee();

    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    // message initalization
    const callMessage = (serverityval, msg, title) => {
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };

    // List of Parameter
    const [selectedPartyID, setSelectedPartyID] = useState(0);
    const [selectedParty, setSelectedParty] = useState(null);
    const [selectedPOID, setSelectedPOID] = useState(0);
    const [selectedPONumber, setSelectedPONumber] = useState(null);

    const [selectedPRID, setSelectedPRID] = useState(0);
    const [selectedPRNumber, setSelectedPRNumber] = useState(null);

    const [selectedInspectionID, setSelectedInspectionID] = useState(0);
    const [selectedInspectionNumber, setSelectedInspectionNumber] = useState(null);

    const [customerNotes, setCustomerNotes] = useState('');
    const [orderFromDate, setOrderFromDate] = useState(dayjs());
    const [approvedDate, setApprovedDate] = useState(dayjs());
    const [orderPurchaseOrderDate, setPurchaseOrderDate] = useState(dayjs());
    const [status, setStatus] = useState('Created');

    const [isLoadEditPO, setLoadEditPO] = useState(false);
    const [isLoadEditPR, setLoadEditPR] = useState(false);

    const [tableRows, setTableRows] = useState([{ id: 1, id_receives: 1, product_code: '', product_description: '', ordered: 0, received: 0, quantity_balance: 0, in_transit: 0, quantity_to_received: 0, return_reason: '' }]);

    const [poNumber, setPONumber] = useState([]);
    const [poID, setPOID] = useState([]);
    const [isPONumberLoaded, setIsPONumberLoaded] = useState(false);

    const [prNumber, setPRNumber] = useState([]);
    const [ptNumber, setPTNumber] = useState([]);
    const [isPRNumberLoaded, setIsPRNumberLoaded] = useState(false);

    // get party list
    const [partyList, setPartyList] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const [selectedButtonName, setSelectedButtonName] = useState('');
    const [selectionMode, setSelectionMode] = useState(0);
    const [updateStatus, setUpdateStatus] = useState(false);
    const [disableBtn, setDisableBtn] = useState(false);


    const callback = () => {
        handlecallback();
    }

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });

    // update selection mode 
    useEffect(() => {
        if (!updateStatus) {
            setSelectionMode(selectedMode);
        }
    }, [selectedMode, setSelectedMode])


    const LoadReceivesDetails = async (PurchaseID) => {
        try {

            const para = { p_companyid: localStorage.getItem('companyid'), purchase_order_id: PurchaseID, p_purchase_return_number: editPurchaseReturnNumber };
            const purchaseOrderResponse = await callApi(API_ENDPOINTS.PURCHSE_RETURN_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para);

            //const purchaseOrderResponse = await callApi(API_ENDPOINTS.PURCHSE_INSPECTION_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para);
            if (purchaseOrderResponse && purchaseOrderResponse.length > 0) {
                const updatedTableData = purchaseOrderResponse.map(row => ({
                    ...row,
                    reason: '', // or provide a default like 'N/A'
                }));
                setTableRows(updatedTableData);
            }
            setSelectedPRID(PurchaseID);

        } catch (error) { callMessage('error', error.message, 'Error'); }
    }

    const LoadInspectionDetails = async (PurchaseID, inspection_number) => {
        try {

            const para = { p_companyid: localStorage.getItem('companyid'), purchase_order_id: PurchaseID, purchase_return_number: inspection_number };
            const purchaseOrderResponse = await callApi(API_ENDPOINTS.PURCHSE_INSPECTION_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para);
            if (purchaseOrderResponse && purchaseOrderResponse.length > 0) {
                const updatedTableData = purchaseOrderResponse.map(row => ({
                    ...row,
                    // reason: '', // or provide a default like 'N/A'
                }));
                setTableRows(updatedTableData);
            }
            setSelectedPRID(PurchaseID);

        } catch (error) { callMessage('error', error.message, 'Error'); }
    }



    const didFetchData = useRef(false);
    const controllerRef = useRef(null);
    //edit inspection call
    useEffect(() => {
        const fetchPurchaseOrderData = async () => {
            // Check if fetch process is already running
            if (didFetchData.current) {
                return;
            }
            didFetchData.current = true;

            // Create an AbortController to cancel fetch if needed
            controllerRef.current = new AbortController();
            const { signal } = controllerRef.current;

            try {

                const isEditPO = !isLoadEditPO && editPurchaseReceiveNumber !== 0 && editPurchaseReturnID === 0;
                const para = { p_companyid: localStorage.getItem('companyid'), purchase_order_id: editPurchaseOrderNumber };
                const purchaseOrderResponse = await callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PURCHASE_ORDER, 'POST', { 'Content-Type': 'application/json' }, para, { signal });

                // Log the response to see its structure
                console.log('purchaseOrderResponse:', purchaseOrderResponse);

                // Check if purchaseOrderResponse is an array and has at least one element
                if (!purchaseOrderResponse || purchaseOrderResponse.length === 0) {
                    throw new Error('No purchase order data found');
                }

                const purchaseOrder = purchaseOrderResponse[0];

                // Check if purchaseOrder has the expected properties
                if (!purchaseOrder || !purchaseOrder.id_party) {
                    throw new Error('Invalid purchase order data');
                }

                const purchasereceivesPara = { p_companyid: localStorage.getItem('companyid'), purchase_order_id: editPurchaseReceiveID, purchase_return_number: isEditPO ? 0 : editPurchaseReturnNumber };
                const purchaseOrderPara = { p_companyid: localStorage.getItem('companyid'), p_partyid: purchaseOrder.id_party };

                const [poData, tableData] = await Promise.all([
                    callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_NUMBER_RECEIVE, 'POST', { 'Content-Type': 'application/json' }, purchaseOrderPara, { signal }),
                    callApi(API_ENDPOINTS.PURCHSE_INSPECTION_DETAILS, 'POST', { 'Content-Type': 'application/json' }, purchasereceivesPara, { signal })
                ]);

                // Log the responses to understand their structure


                if (poData && poData.length > 0) setPONumber(poData);

                if (tableData && tableData.length > 0) setTableRows(tableData);

                if (purchaseOrder) {
                    const selected = poData.find(po => po.po_number === purchaseOrder.purchase_order_number);
                    if (selected) {
                        setSelectedPONumber(selected);
                        setSelectedPOID(selected.id);
                    }
                    setSelectedPartyID(purchaseOrder.id_party);
                    updatePartyListAndSetSelectedParty(purchaseOrder.id_party);
                }

                // updateFormData(mappedRows, purchaseOrder);

                didFetchData.current = false; // Reset the flag after fetching data
            } catch (error) {
                if (signal.aborted) {
                    console.log('Fetch aborted');
                } else {
                    callMessage('error', error.message, 'Error');
                    console.error('Error:', error);
                }
                didFetchData.current = false; // Reset the flag if an error occurs
            }
        };

        // Only call fetchPurchaseOrderData if necessary
        if (!didFetchData.current) {
            fetchPurchaseOrderData();
        }

        // Cleanup function to cancel fetch if the component unmounts
        return () => {
            if (controllerRef.current) {
                controllerRef.current.abort();
            }
        };
    }, [editPurchaseOrderNumber, editPurchaseReceiveID]);


    const updatePartyListAndSetSelectedParty = (selectedPartyID) => {
        const para = { p_companyid: localStorage.getItem('companyid'), }
        callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setPartyList(data);
                    const selected = data.find(party => party.id === selectedPartyID);
                    if (selected) {
                        setSelectedParty(selected);
                        handleGetPRList(selectedPartyID);
                    }
                }
            })
            .catch(error => { callMessage('error', error.message, 'Error'); });
    };




    const handleQuantityChange = (index, quantity) => {
        setTableRows((prevRows) => {
            return prevRows.map((row, i) => {
                if (i === index) {
                    const numericQuantity = Number(quantity); // Ensure quantity is a number
                    return (row.quantity_balance + row.received) <= numericQuantity
                        ? row  // Return unchanged row if condition is not met
                        : { ...row, quantity_to_received: quantity }; // Create a new object for state change detection
                }
                return row;
            });
        });
    };


    const handleReasonChange = (index, reason) => {
        const newRows = [...tableRows];
        newRows[index].return_reason = reason;
        setTableRows(newRows);
    };

    useEffect(() => {
        if (!isDataLoaded) {

            const para = { p_companyid: localStorage.getItem('companyid'), }

            callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => { if (data && data.length > 0) { setPartyList(data); } })
                .catch(error => { callMessage('error', error.message, 'Error'); });
        }

    }, [isDataLoaded]);


    useEffect(() => {
        if (!isPONumberLoaded) {
            if (editPurchaseOrderNumber = 0) {

                const para = { p_companyid: localStorage.getItem('companyid'), p_modeid: 0, }

                callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_NUMBER, 'POST', { 'Content-Type': 'application/json' }, para)
                    .then(data => { if (data && data.length > 0) { setPONumber(data[0].po_number); } })
                    .catch(error => { callMessage('error', error.message, 'Error'); });

            }
        }
    }, [isPONumberLoaded]);

    // purchase received list
    const handleGetPRList = (PartyID) => {

        let mode = (selectionMode === 0 || selectionMode === 53) ? ('new-inspection') : (editPurchaseReturnID === 0 ? 'inspection' : 'all');

        if (editPurchaseReturnID == 0) {
            mode = (selectionMode === 0 || selectionMode === 53) ? 'new-inspection' : 'inspection';
        } else {
            mode = 'all';
        }


        const para = { p_companyid: localStorage.getItem('companyid'), p_partyid: PartyID, p_modeid: 0, p_mode: mode }

        callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PT_NUMBER_RECEIVE, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setPRNumber(data);

                    if (editPurchaseReceiveID !== 0) {
                        const selected = data.find(po => po.id_receive === editPurchaseReceiveID);
                        setSelectedPRNumber(selected);
                        setSelectedPRID(selected.id_receive);
                        // LoadReceivesDetails(selected.id_receive);
                        setPONumber(selected.po_number);
                        setPOID(selected.id);
                        setSelectedPOID(selected.id);
                        setPurchaseOrderDate(selected.po_date);
                    }



                }
            })
            .catch(error => { callMessage('error', error.message, 'Error'); });
    }

    const handleGetPTList = (PartyID) => {

        const para = { p_companyid: localStorage.getItem('companyid'), p_partyid: PartyID, }

        callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_NUMBER_RECEIVE, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => { if (data && data.length > 0) { setPONumber(data); } })
            .catch(error => { callMessage('error', error.message, 'Error'); });
    }



    useEffect(() => {
        if (!isPRNumberLoaded) {
            if (editPurchaseReturnID === 0) {

                const para = { p_companyid: localStorage.getItem('companyid'), p_modeid: 0, }
                callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_INSPECTION_NUMBER, 'POST', { 'Content-Type': 'application/json' }, para)
                    .then(data => { if (data && data.length > 0) { setPTNumber(data[0].pr_number); } })
                    .catch(error => { callMessage('error', error.message, 'Error'); });
            }
            else {
                setPTNumber(editPurchaseReturnNumber);
            }
        }
    }, [isPRNumberLoaded]);

    const id = editPurchaseReturnID !== 0 ? editPurchaseReturnID : selectedInspectionID;

    usePurchaseInspectionDetailsById({ id, approvedByHook, inspiredByHook, setOrderFromDate, setCustomerNotes, callMessage, setStatus, });


    const validateRequestBody = () => {
        const errors = [];

        const modifiedRows = tableRows.map(({ product, account, ...rest }) => rest);

        if (!localStorage.getItem('companyid')) errors.push("Company ID is missing.");
        if (!selectedPartyID) errors.push("Party is not selected.");
        if (!selectedPOID) errors.push("PO Number is not selected.");
        if (!ptNumber) errors.push("PR Number is required.");
        if (!orderFromDate || !dayjs(orderFromDate).isValid()) errors.push("Invalid or missing Order Date.");
        if (!Array.isArray(modifiedRows) || modifiedRows.length === 0) errors.push("At least one product must be added.");
        if (!selectedPRID) errors.push("Receive ID is required.");
        if (!inspiredByHook.selectedEmployeeID) errors.push("Inspected By is required.");
        if (selectionMode === 1) {
            if (!approvedByHook.selectedEmployeeID) errors.push("Approved By is required.");
            if (!approvedDate || !dayjs(approvedDate).isValid()) errors.push("Invalid or missing Approved Date.");
        }

        return errors;
    };



    const handleSaveAndDraft = () => {

        const validationErrors = validateRequestBody();
        if (validationErrors.length > 0) {
            // Join errors into a single string (you can style this as needed)
            const errorMessage = validationErrors.map((msg, i) => `${i + 1}. ${msg}`).join('\n');
            callMessage('error', errorMessage, 'Validation Error');
            return;
        }

        const modifiedRows = tableRows.map(({ product, account, ...rest }) => rest);
        let currentMode = editPurchaseReturnID !== 0 ? editPurchaseReturnID : 0;

        let inspectionID = 0;

        if (editPurchaseReturnID == 0) {
            inspectionID = selectedInspectionID;
        } else {
            inspectionID = editPurchaseReturnID;
        }


        const requestBody = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_modeid: currentMode,
            p_partyid: selectedPartyID,
            p_po_number_id: selectedPOID,
            p_pr_number: ptNumber,
            p_date: dayjs(orderFromDate).format('YYYY-MM-DD hh:mm:ss'),
            p_customer_notes: customerNotes,
            p_product_list: modifiedRows,
            p_id_receives: selectedPRID,
            p_approvedby: approvedByHook.selectedEmployeeID,
            p_insepiredby: inspiredByHook.selectedEmployeeID,
            p_approved_date: dayjs(approvedDate).format('YYYY-MM-DD hh:mm:ss'),
            p_inspection_id: inspectionID,
        }

        const apiEndpoint = (selectionMode === 0 || selectionMode === 53)
            ? API_ENDPOINTS.PURCHASE_CREATE_INSPECTION
            : API_ENDPOINTS.PURCHASE_APPROVAL_INSPECTION;

        callApi(apiEndpoint, 'POST', { 'Content-Type': 'application/json' }, requestBody)
            .then(data => {
                const successMessage = (selectionMode === 0 || selectionMode === 53)
                    ? (editPurchaseReturnID !== 0
                        ? 'Purchase Inspection Updated Successfully'
                        : 'New Purchase Inspection Added Successfully')
                    : 'Purchase inspection Approved Successfully';
                if (data && data.length > 0) { callMessage('info', successMessage, 'info'); setDisableBtn(true); } else { setDisableBtn(false); }
            })
            .catch(error => { callMessage('error', error.message, 'Error'); });
    };



    // load report data 

    const [allPOData, setAllPOData] = useState({});

    const updateFormData = (productData, purchaseOrder) => {
        const subtotal = productData.reduce((sum, item) => sum + item.amount, 0);
        const totalQuantity = productData.reduce((sum, item) => sum + item.quantity, 0);

        const formData = {
            partyName: purchaseOrder.company, // Update as per your requirement
            purchaseOrderNumber: purchaseOrder.purchase_order_number,
            referenceNumber: purchaseOrder.reference,
            date: dayjs(purchaseOrder.po_date).format('DD-MMM-YYYY'),
            expectedDeliveryDate: dayjs(purchaseOrder.expiry_delivery_date).format('DD-MMM-YYYY'),
            paymentTerms: purchaseOrder.payment_description, // Fetch from data if available
            shipmentPreference: purchaseOrder.shipment_reference,
            products: productData.map(item => ({
                code: item.product.code,
                description: item.product.description,
                account: item.account.description,
                quantity: item.quantity,
                rate: item.rate,
                amount: item.amount,
            })),
            customerNotes: purchaseOrder.customer_notes,
            termsConditions: purchaseOrder.terms_conditions,
            subtotal: subtotal,
            totalQuantity: totalQuantity,
            discountPercentage: purchaseOrder.discount_percentage, // Fetch from data if available
            discountValue: purchaseOrder.discount_value,
            adjustment: purchaseOrder.adjustment_value,
            tcsPercentage: '1%', // Fetch from data if available
            tcsValue: purchaseOrder.tcs_value,
            cgstPercentage: purchaseOrder.cgst_percentage,
            cgst: purchaseOrder.cgst,
            sgstPercentage: purchaseOrder.sgst_percentage,
            sgst: purchaseOrder.sgst,
            // total: subtotal - (subtotal * 0.05) + adjustment + (subtotal * 0.01), // Example calculation
            fright: purchaseOrder.fright,
        };
        setAllPOData(formData);
        // Generate PDF (example)
        // generatePDF(formData);
    };

    const handleSubMenu = async () => {
        if (selectedButtonName === 'ApproveInspection') {
            setSelectedMode(1);
            setSelectionMode(1);
        }
    }


    return (<>


        <Box padding={0}>

            {(selectionMode === 0 || selectionMode === 53) ? (
                <Header title={editPurchaseOrderNumber == 0 ? 'New Purchase Insepections' : 'Edit Purchase Inspections'} subtitle="" callback={callback} />
            ) : (
                <Header
                    title={editPurchaseReturnID === 0 ? 'Approve Purchase Insepections' : 'Edit Approve Purchase Inspections'}
                    subtitle=""
                    callback={callback}
                />
            )}
            <Divider />



            {editPurchaseOrderNumber > 0 && (
                <>
                    <PurchaseInspectionActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handleSubMenu} selectionMode={selectionMode} />
                    <Divider />
                </>
            )}

            <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

 <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 1,
            py: 1
          }}
        >
          <Typography variant="h6"  >
            <span style={{ color: 'red' }}>*</span> Mandatory fields
          </Typography>
        </Box>
            <ResponsiveBox
                customMaxHeight={{
                    xs: '72vh', // Extra small devices (phones)
                    sm: '72vh', // Small devices (tablets)
                    md: '74vh', // Medium devices (small laptops)
                    lg: '74vh', // Large devices (desktops)
                    xl: '82vh', // Extra large devices (large desktops)
                }}>

                <Grid container  >

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ backgroundColor: colors.primary[400] }}  >
                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center">

                            <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Party Name   <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    options={partyList}
                                    value={selectedParty}
                                    // disabled={selectionMode === 1}
                                    onChange={(event, newValue) => {
                                        setSelectedParty(newValue);
                                        setSelectedPartyID(newValue.id);

                                        handleGetPRList(newValue.id);
                                    }}
                                    getOptionLabel={(option) => option.companyname || ''}
                                    renderInput={(params) => (
                                        <TextField {...params} label="" required variant="outlined" />
                                    )}
                                />
                            </Grid>

                        </Grid>


                        {(selectionMode === 0 || selectionMode === 53) ? (
                            <Grid container padding="10px 0px 15px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >
                                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Purchase Receive #  <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={prNumber}
                                        // disabled={selectionMode === 1}
                                        value={selectedPRNumber}
                                        onChange={(event, newValue) => {
                                            setSelectedPRNumber(newValue);
                                            setSelectedPRID(newValue.id_receive);
                                            LoadReceivesDetails(newValue.id_receive);
                                            setPONumber(newValue.po_number);
                                            setPOID(newValue.id);
                                            setSelectedPOID(newValue.id);
                                            setPurchaseOrderDate(newValue.po_date);
                                        }}
                                        getOptionLabel={(option) => option.receive_number || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid container padding="10px 0px 15px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >
                                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Purchase Inspection #
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={prNumber}
                                        // disabled={editPurchaseReturnID !== 0}
                                        value={selectedPRNumber}
                                        onChange={(event, newValue) => {
                                            setSelectedInspectionNumber(newValue);
                                            setSelectedInspectionID(newValue.id_inspection);
                                            setSelectedPRNumber(newValue);
                                            setSelectedPRID(newValue.id_receive);
                                            LoadInspectionDetails(newValue.id_receive, newValue.inspection_number);
                                            setPONumber(newValue.po_number);
                                            setPOID(newValue.id);
                                            setSelectedPOID(newValue.id);
                                            setPurchaseOrderDate(newValue.po_date);
                                        }}
                                        getOptionLabel={(option) => option.inspection_number || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        )}

                    </Grid>

                    {(selectionMode === 0 || selectionMode === 53) ? (

                        <Grid item xs={12} xl={12} >

                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Purchase Inspection No#  <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                    <TextField value={ptNumber} fullWidth size="small" label="" required variant="outlined"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    <CustomTooltip
                                                        title={
                                                            <span>
                                                                <b>click here to enable or disable auto generation of purchase order number.</b> <br />
                                                            </span>}
                                                    >
                                                        <SettingsIcon style={{ fontSize: "20px" }} />
                                                    </CustomTooltip>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>

                            </Grid>
                        </Grid>) : (
                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >
                            <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Purchase Receive # <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    options={prNumber}
                                    disabled={true}
                                    value={selectedPRNumber}
                                    onChange={(event, newValue) => {
                                        setSelectedPRNumber(newValue);
                                        setSelectedPRID(newValue.id_receive);
                                        LoadReceivesDetails(newValue.id_receive);
                                        setPONumber(newValue.po_number);
                                        setPOID(newValue.id);
                                        setSelectedPOID(newValue.id);
                                        setPurchaseOrderDate(newValue.po_date);
                                    }}
                                    getOptionLabel={(option) => option.receive_number || ''}
                                    renderInput={(params) => (
                                        <TextField {...params} label="" required variant="outlined" />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    )}

                    <Grid item xs={12} xl={12} >
                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >
                            <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Purchase Order #  <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                <TextField fullWidth size="small" value={poNumber} />
                            </Grid>

                            <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Purchase Date <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Stack spacing={2}>
                                        <DatePicker
                                            size="small"
                                            id="Orderdate"
                                              format="DD-MMM-YYYY"
                                            value={dayjs(orderFromDate)}
                                            disabled={selectionMode === 1}
                                            onChange={(date) => setOrderFromDate(date)}
                                            slotProps={{ textField: { size: 'small' } }}
                                            fullWidth
                                            className="customDatePicker"
                                            renderInput={(props) => (
                                                <TextField required {...props} />
                                            )}
                                        />
                                    </Stack>
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                    </Grid>


                    <Grid item xs={12} xl={12} >
                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                            <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Inspection Date  <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Stack spacing={2}>
                                        <DatePicker
                                            size="small"
                                            id="Orderdate"
                                              format="DD-MMM-YYYY"
                                            value={dayjs(orderFromDate)}
                                            disabled={selectionMode === 1}
                                            onChange={(date) => setOrderFromDate(date)}
                                            slotProps={{ textField: { size: 'small' } }}
                                            fullWidth
                                            className="customDatePicker"
                                            renderInput={(props) => (
                                                <TextField required {...props} />
                                            )}
                                        />
                                    </Stack>
                                </LocalizationProvider>
                            </Grid>


                            <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Inspected By  <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                                <EmployeeSelector
                                    // label="Inspected By"
                                    employeeList={inspiredByHook.employee}

                                    selectedEmployee={inspiredByHook.selectedEmployee}
                                    onChange={(val) => {
                                        inspiredByHook.setSelectedEmployee(val);
                                        inspiredByHook.setSelectedEmployeeID(val?.id);
                                    }}
                                    disable={selectionMode === 1}
                                />
                            </Grid>

                        </Grid>
                    </Grid>

                    {(selectionMode === 0 || selectionMode === 53) ? (
                        null
                    ) : (
                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Approved Date  <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={2}>
                                            <DatePicker
                                                size="small"
                                                id="Orderdate"
                                                format="DD-MMM-YYYY"
                                                value={dayjs(approvedDate)}
                                                onChange={(date) => setApprovedDate(date)}
                                                slotProps={{ textField: { size: 'small' } }}
                                                fullWidth
                                                className="customDatePicker"
                                                renderInput={(props) => (
                                                    <TextField required {...props} />
                                                )}
                                            />
                                        </Stack>
                                    </LocalizationProvider>
                                </Grid>


                                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Approved By  <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                                    <EmployeeSelector
                                        // label="Approved By"
                                        employeeList={approvedByHook.employee}
                                        selectedEmployee={approvedByHook.selectedEmployee}
                                        onChange={(val) => {
                                            approvedByHook.setSelectedEmployee(val);
                                            approvedByHook.setSelectedEmployeeID(val?.id);
                                        }}
                                    />
                                </Grid>

                            </Grid>
                        </Grid>
                    )}





                    <Grid item xs={12} lg={11.5} xl={11.5} mt={5} >
                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >

                            <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center" >
                                <CustomTableContainer colors={colors}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Product</TableCell>
                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Ordered</TableCell>
                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Rejected</TableCell>
                                                    {/* <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>In Trasit</TableCell> */}
                                                    {(selectionMode === 0 || selectionMode === 53) ? (
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Quantity to Reject</TableCell>
                                                    ) : (null)}
                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'left' }}>Reject Reason</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {tableRows.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell style={{ size: "small", width: "300px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                            <TextField
                                                                fullWidth
                                                                disabled
                                                                size="small"
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '8px',
                                                                        textAlign: 'left',
                                                                    },
                                                                }}
                                                                variant="outlined"
                                                                type="text"
                                                                value={`${row.product_code} - ${row.product_description}`}
                                                            />
                                                        </TableCell>

                                                        <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                                            <TextField
                                                                fullWidth
                                                                disabled
                                                                size="small"
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '8px',
                                                                        textAlign: 'right',
                                                                    },
                                                                }}
                                                                variant="outlined"
                                                                type="number"
                                                                value={row.ordered}
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                            <TextField
                                                                fullWidth
                                                                disabled
                                                                size="small"
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '8px',
                                                                        textAlign: 'right',
                                                                    },
                                                                }}
                                                                variant="outlined"
                                                                type="number"
                                                                value={row.received}
                                                            />
                                                        </TableCell>
                                                        {/* <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '8px',
                                                                        textAlign: 'right',
                                                                    },
                                                                }}
                                                                value={row.in_transit}
                                                                variant="outlined"
                                                                disabled
                                                            />
                                                        </TableCell> */}
                                                        {(selectionMode === 0 || selectionMode === 53) ? (
                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'right',
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="number"
                                                                    value={row.quantity_to_received}
                                                                    onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                                />
                                                            </TableCell>
                                                        ) : (null)}
                                                        <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '8px',
                                                                        textAlign: 'left',
                                                                    },
                                                                }}
                                                                variant="outlined"
                                                                type="text"
                                                                value={row.return_reason}
                                                                onChange={(e) => handleReasonChange(index, e.target.value)}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </CustomTableContainer>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} lg={12} xl={12} mt={1} padding={2} >
                        <Box padding={1} sx={{
                            display: 'flex',
                            alignItems: 'center',
                            borderColor: 'divider',
                            borderRadius: 2,
                            color: 'text.secondary', '& svg': { m: 1, },
                        }} >
                            <Grid container spacing={0}>
                                <Grid item xs={6} lg={6.4} xl={6} marginRight={1}>
                                    <Typography variant="h5" fontWeight="bold">Notes (For Internal Use) </Typography>
                                    <Grid item xs={12} lg={12} xl={10}>
                                        <TextField
                                            id="outlined-multiline-static"
                                            value={customerNotes}
                                            onChange={(e) => setCustomerNotes(e.target.value)}
                                            placeholder="Enter the customer notes , will appear the purchase order."
                                            multiline
                                            rows={4}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </ResponsiveBox>

            <Grid container>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                    <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
                        <Toolbar>
                            {(selectionMode === 0 || selectionMode === 53) ? (<>
                                {status === 'Created' && (
                                    <Button size="small" variant="contained" disabled={disableBtn} color="secondary" onClick={handleSaveAndDraft} startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save Inspection</Button>
                                )}
                            </>) : (<>
                                <Button size="small" variant="contained" disabled={disableBtn} color="secondary" onClick={handleSaveAndDraft} startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Approve Inspection</Button>
                            </>)}

                            <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
                        </Toolbar>
                    </Box>
                </Grid>
            </Grid>

        </Box>

    </>)
}
export default AddNewPurchaseInspection;